import { render, staticRenderFns } from "./RecordQuestionValidation.vue?vue&type=template&id=f0c78100&scoped=true"
import script from "./RecordQuestionValidation.vue?vue&type=script&lang=js"
export * from "./RecordQuestionValidation.vue?vue&type=script&lang=js"
import style0 from "./RecordQuestionValidation.vue?vue&type=style&index=0&id=f0c78100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c78100",
  null
  
)

export default component.exports